// extracted by mini-css-extract-plugin
module.exports = {"pindent":"saleModal_pindent__EJjvz","newStyle":"saleModal_newStyle__O__vq"};